




















































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { CommentAPI, PipelineAPI, ReferralAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { Comment } from '@/api/model/comment'
import { Pipeline } from '@/api/model/pipeline'
import { CommentOrigin, CommentVisibility } from '@/api/types'

@Component
export default class TransferReferralModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean
    visible: boolean = false
    loading: boolean = false
    selectedBranch: Branch = null
    selectedUser: User = null
    pipeline: Pipeline|null = null

    mounted(): void {
        this.loadReferralPipeline()
    }

    async loadReferralPipeline(): Promise<void> {
        if (!this.referral.pipeline) {
            return
        }

        this.pipeline = await PipelineAPI.get(this.referral.pipeline.id)
    }

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async transferReferral(): Promise<void> {
        try {
            this.loading = true
            const previousBranch = this.referral.assignedToBranch

            await ReferralAPI.update(this.referral.id, {
                ...this.referral,
                assignedToBranch: this.selectedBranch,
                assignedTo: this.selectedUser,
            } as Referral)

            await CommentAPI.create(Comment.fromData({
                referral: this.referral.resourceIdentifier,
                user: null,
                id: uuid(),
                comment: this.$t('referral.transfer.comment', {
                    user: this.$currentUser.name,
                    source: previousBranch.name,
                    target: this.selectedBranch.name,
                }),
                origin: CommentOrigin.SYSTEM,
                visibility: CommentVisibility.PUBLIC,
            }))

            this.$emit('on-save')
            this.hideModal()

        } finally {
            this.loading = false
        }
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
    }

    get availableBranches(): Branch[] {
        if (this.pipeline) {
            return this.pipeline.branches
        }

        // Legacy
        return this.$currentCompany.getAvailableBranches()
            .filter(branch => branch.acceptsReferralType(this.referral.type))
    }

    get availableUsers(): User[] {
        if (this.selectedBranch === null) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.selectedBranch,
        })
    }
}
